<template>
  <div class="advance-reporting-header-section">
    <ErrorHandler v-if="error != null" :error="error" @done="error = null" />
    <div class="header-top-row">
      <div class="header-left">
        <div v-if="schools.length > 0" class="school-select-field">
          <SchoolMultiSelect
            :schools="schools"
            :model-value="selectedSchools"
            placeholder="Select school(s)"
            @update:model-value="handleSchoolChange"
          />
        </div>
      </div>
      <div class="header-right">
        <div class="action-buttons">
          <button
            class="action-btn"
            @click="handleDownload"
            data-testid="download-report-btn"
            title="Download Report"
          >
            <i class="ri-download-line"></i>
          </button>
          <div class="divider"></div>
          <button
            class="action-btn"
            @click="handleEmail"
            data-testid="email-report-btn"
            title="Email Report"
          >
            <i class="ri-mail-line"></i>
          </button>
          <div class="divider"></div>
          <button
            class="action-btn"
            @click="handleSchedule"
            data-testid="schedule-report-btn"
            title="Schedule Report"
          >
            <i class="ri-settings-3-line"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="card-title-container">
      <p class="card-title">{{ usersKpiTitle }}</p>
      <VTooltip>
        <template #popper>
          <div>
            {{ usersKpiInformation }}
          </div>
        </template>
        <div class="card-title-info-icon">
          <i class="ri-information-line"></i>
        </div>
      </VTooltip>
    </div>
  </div>
</template>

<script>
import advanceReportingConfigs from "@/configs/advanceReportingConfigs"
import advanceReportingConstants from "@/constants/advanceReportingConstants"
import ExportReportPopUp from "@/v3components/AdvanceReporting/ExportReportPopUp.vue"
import ScheduleReportPopUp from "@/v3components/AdvanceReporting/ScheduleReportPopUp.vue"
import SchoolMultiSelect from "@/v3components/AdvanceReporting/SchoolMultiSelect.vue"
import ErrorHandler from "@/v3components/VisitorErrorHandler.vue"
import { computed, inject, ref } from "vue"
import { useStore } from "vuex"

export default {
  name: "PageHeader",
  components: {
    SchoolMultiSelect,
    ErrorHandler
  },
  setup() {
    const store = useStore()
    const modal = inject("modal")
    const cancelToken = inject("advanceReportingCancelToken", null)
    const error = ref(null)

    const schools = computed(
      () => store?.getters?.["advanceReportingStore/schoolList"] || []
    )
    const selectedSchools = computed(() => {
      const schools = store?.state?.advanceReportingStore?.selectedSchools
      return schools || []
    })

    const usersKpiTitle =
      advanceReportingConstants.CHART_ID_VS_TITLE[
        advanceReportingConstants.DEFAULT_CHART_IDS.USERS_KPI
      ]

    const usersKpiInformation =
      advanceReportingConstants.CHART_ID_VS_INFORMATION[
        advanceReportingConstants.DEFAULT_CHART_IDS.USERS_KPI
      ]

    const handleSchoolChange = async (selectedSchoolsArray) => {
      try {
        error.value = null
        store?.commit(
          "advanceReportingStore/setSelectedSchools",
          selectedSchoolsArray
        )
        if (selectedSchoolsArray.length > 0) {
          await store?.dispatch(
            "advanceReportingStore/fetchAdvanceReportingPageData",
            { cancelToken }
          )
        }
      } catch (err) {
        error.value = err
      }
    }

    const handleDownload = () => {
      modal.open(ExportReportPopUp, {
        visible: true,
        size: "lg",
        title: "Download Report",
        props: {}
      })
    }

    const handleEmail = () => {
      modal.open(ExportReportPopUp, {
        visible: true,
        size: "lg",
        title: "Email Report",
        props: {
          isEmailMode: true
        }
      })
    }

    const handleSchedule = () => {
      modal.open(ScheduleReportPopUp, {
        visible: true,
        size: "lg",
        title: "Schedule Report",
        props: {}
      })
    }

    return {
      advanceReportingConfigs,
      usersKpiTitle,
      usersKpiInformation,
      schools,
      selectedSchools,
      error,
      handleSchoolChange,
      handleDownload,
      handleEmail,
      handleSchedule
    }
  }
}
</script>
